import { showErrorToast } from '@/components/ui/sonner.jsx'

export function throwException(error) {
  showErrorToast('Đã xảy ra lỗi', {
    description: error?.message,
  })
}
